var map = {
	"./add-to-cart.svg": 9943,
	"./address.svg": 2206,
	"./arrow-down.svg": 6276,
	"./arrow-up.svg": 1224,
	"./cart-arrow-close.svg": 6138,
	"./cart-arrow-expand.svg": 2472,
	"./cart.svg": 4467,
	"./check.svg": 3028,
	"./colombia.svg": 6726,
	"./confirmation-dark.svg": 1604,
	"./confirmation-green.svg": 6774,
	"./confirmation-white.svg": 5511,
	"./delete.svg": 7054,
	"./delivery-dark.svg": 617,
	"./delivery-green.svg": 3394,
	"./delivery-location.svg": 5758,
	"./delivery-small.svg": 3531,
	"./delivery-white.svg": 4113,
	"./delivery.svg": 7147,
	"./done.svg": 523,
	"./dots.svg": 1479,
	"./edit.svg": 2365,
	"./exit.svg": 4953,
	"./eye-off.svg": 6427,
	"./eye.svg": 9947,
	"./google.svg": 5430,
	"./info.svg": 3974,
	"./instagram-white.svg": 6723,
	"./instagram.svg": 5392,
	"./leaf.svg": 3080,
	"./location.svg": 1618,
	"./mail-white.svg": 7583,
	"./mail.svg": 2711,
	"./orders.svg": 1431,
	"./phone-white.svg": 7267,
	"./phone.svg": 4436,
	"./picture.svg": 6860,
	"./preparation-dark.svg": 406,
	"./preparation-green.svg": 1105,
	"./preparation-white.svg": 8646,
	"./register.svg": 4383,
	"./remove-from-cart.svg": 6778,
	"./repeat.svg": 4505,
	"./search.svg": 7618,
	"./user.svg": 2676,
	"./whatsapp-white.svg": 3155,
	"./whatsapp.svg": 6299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2107;